import React from "react";
import "./styles.css";
import Home from "./routes/Home";
import About from "./routes/About";
import Service from "./routes/Service";
import Contact from "./routes/Contact";
import Expertise from "./routes/Expertise";
import FinancialDiplomacy from "./routes/FinancialDiplomacy";
import PublicationsAndInsightsPage from "./routes/PublicationsAndInsightsPage";
import PrivacyPolicy from "./routes/PrivacyPolicy";
import ScrollToTop from "./components/ScrollToTop";

import { Route, Routes } from "react-router-dom";

function App() {
  return (
    <div className="App">
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/service" element={<Service />} />
        <Route path="/expertise" element={<Expertise />} />
        <Route path="/findip" element={<FinancialDiplomacy />} />
        <Route path="/insights" element={<PublicationsAndInsightsPage />} />
        <Route path="/privacy" element={<PrivacyPolicy />} />
        <Route path="/contact" element={<Contact />} />

        {/* <Navbar />
      <Home />
      <Destination />
      <Trip />
      <Footer /> */}
      </Routes>
    </div>
  );
}

export default App;
